import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import CategoryDisplay from './components/CategoryDisplay/CategoryDisplay';
import * as serviceWorker from './serviceWorker';

const categoryDisplay = document.getElementById('category-display');
if(categoryDisplay){
  const collectionId = categoryDisplay.getAttribute('collectionId') || '';
  ReactDOM.render(<CategoryDisplay collectionId={collectionId}/>, categoryDisplay);
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
